"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class FormClient extends authenticated_client_1.AuthenticatedClient {
    findFormBySnapshotId(projectId, snapshotId, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/snapshots/${snapshotId}/forms`;
            const response = yield this.httpGet(url + (fields ? `?fields=${fields}` : ''));
            return response.payload;
        });
    }
    createForm(projectId, formCreateRequest) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/forms`;
            const response = yield this.httpPost(url, formCreateRequest);
            return response.payload;
        });
    }
    updateForm(projectId, id, formUpdateRequest) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/forms/${id}`;
            const response = yield this.httpPut(url, formUpdateRequest);
            return response.payload;
        });
    }
    deleteForm(projectId, id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/forms/${id}`;
            const response = yield this.httpDelete(url);
            return response.payload;
        });
    }
}
exports.FormClient = FormClient;
//# sourceMappingURL=form.client.js.map